module.exports = __webpack_public_path__ + "img/ico_noticias.d31b6b24.svg";